import React, { Suspense, lazy } from 'react'
import { ROUTE_PATH } from '../helpers'
import { Route, Redirect, Switch } from 'react-router-dom'
import {
  EnglishAuctionTutorial,
  RFQTutorial,
} from '../containers/TipsAndTutorialContainer'
import {
  HomeContainer,
  BannerDetailFormContainer,
  BannerManagementContainer,
  BuyerDetailFormContainer,
  BuyerEditFormContainer,
  BuyerManagementContainer,
  CategoryManagementContainer,
  CategoryBusinessGroupFormContainer,
  CategoryServiceGroupFormContainer,
  CompanyProfileBuyerFormContainer,
  CompanyProfileSupplierFormContainer,
  ComprehensiveAssessmentManagementContainer,
  ESGVerificationContainer,
  ESGVerificationDetailFormContainer,
  SupplierDetailFormAdminContainer,
  SupplierDetailFormAdminRejectContainer,
  SupplierDiscoveryContainer,
  SupplierDiscoveryInformationContainer,
  SupplierManagementAdminContainer,
  SupplierManagementBuyerContainer,
  UserDetailFormBuyerContainer,
  UserDetailFormAdminContainer,
  UserDetailFormSupplierContainer,
  UserEditFormBuyerContainer,
  UserEditFormAdminContainer,
  UserEditFormSupplierContainer,
  UserManagementBuyerContainer,
  UserManagementAdminContainer,
  UserManagementSupplierContainer,
  ActivatedContainer,
  ContactAdminContainer,
  ResendEmailContainer,
  ResetPasswordContainer,
  SustainabilityPreAssessmentManagementContainer,
  UploadSustainabilityPreAssessmentFormAdminContainer,
  UploadSustainabilityFormContainer,
  UploadRegulatoryContainer,
  UploadComprehensiveAssessmentFormContainer,
  UploadSupplierFormAdminContainer,
  UploadSupplierFormBuyerContainer,
  AnnouncementManagementContainer,
  AnnouncementDetailFormContainer,
  RiskScoreManagementContainer,
  SupplierRegistrationFormContainer,
  SupplierEditFormAdminContainer,
  SuppilerEditWaitActiveContainer,
  SuppilerEditWaitApproveContainer,
  LinkTokenExpriedContainer,
  SupplierManagementInformationEditContainer,
  SourcingProjectDetailContainer,
  SourcingDetailBuyerFormContainer,
  SourcingDetailSupplierFormContainer,
  LinkHaveAccountContainer,
  SourcingCompareEventContainer,
  OnlineTemplateManegementContainer,
  SupplierOnlineManagementContainer,
  BuyerOnlineManagementContainer,
  SourcingProjectsContainer,
  SourcingAuctionBuyerContainer,
  SourcingAuctionSupplierContainer,
  SourcingBuyerContainer,
  SourcingSupplierContainer,
} from './index'

import LogInContainer from './LoginContainer'

const withSuspense = Component => {
  // return Component
  return (props = {}) => (
    // <Suspense fallback="">
    //   <Component {...props} />
    // </Suspense>
    <Component exact {...props} />
  )
}

export const routes = {
  auth: role => (
    <Switch>
      <Route
        exact
        path={ROUTE_PATH.HOME.LINK}
        component={withSuspense(HomeContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.BUYER_MANAGEMENT.LINK}
        component={withSuspense(BuyerManagementContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.UPLOAD_SUSTAINABILITY_BUYER.LINK}
        component={withSuspense(UploadSustainabilityFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.UPLOAD_REGULATORY.LINK}
        component={withSuspense(UploadRegulatoryContainer)}
      />
      <Route
        path={ROUTE_PATH.BUYER_DETAIL_FORM.LINK}
        component={withSuspense(BuyerDetailFormContainer)}
      />
      <Route
        path={ROUTE_PATH.BUYER_EDIT_FORM.LINK}
        component={withSuspense(BuyerEditFormContainer)}
      />
      <Route
        path={ROUTE_PATH.COMPANY_PROFILE_FORM_BUYER.LINK}
        component={withSuspense(CompanyProfileBuyerFormContainer)}
      />
      <Route
        path={ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK}
        component={withSuspense(CompanyProfileSupplierFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.HOME.LINK}
        component={withSuspense(HomeContainer)}
      />
      <Route
        path={ROUTE_PATH.BUYER_DETAIL_FORM.LINK}
        component={withSuspense(BuyerDetailFormContainer)}
      />
      <Route
        path={ROUTE_PATH.BUYER_EDIT_FORM.LINK}
        component={withSuspense(BuyerEditFormContainer)}
      />
      <Route
        path={ROUTE_PATH.SUPPLIER_DETAIL_FORM_ADMIN.LINK}
        component={withSuspense(SupplierDetailFormAdminContainer)}
      />
      <Route
        path={ROUTE_PATH.SUPPLIER_DETAIL_FORM_ADMIN_REJECT.LINK}
        component={withSuspense(SupplierDetailFormAdminRejectContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SUPPLIER_EDIT_FORM_ADMIN_WAIT_APPROVE.LINK}
        component={withSuspense(SuppilerEditWaitApproveContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SUPPLIER_EDIT_FORM_ADMIN_WAIT_ACTIVE.LINK}
        component={withSuspense(SuppilerEditWaitActiveContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SUPPLIER_EDIT_FORM_ADMIN.LINK}
        component={withSuspense(SupplierEditFormAdminContainer)}
      />

      <Route
        path={ROUTE_PATH.SUPPLIER_DISCOVERY.LINK}
        component={withSuspense(SupplierDiscoveryContainer)}
      />
      <Route
        path={ROUTE_PATH.SUPPLIER_DISCOVERY_INFORMATION.LINK}
        component={withSuspense(SupplierDiscoveryInformationContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK}
        component={withSuspense(SupplierManagementAdminContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SUPPLIER_MANAGEMENT_BUYER.LINK}
        component={withSuspense(SupplierManagementBuyerContainer)}
      />
      <Route
        path={ROUTE_PATH.USER_DETAIL_FORM_BUYER.LINK}
        component={withSuspense(UserDetailFormBuyerContainer)}
      />
      <Route
        path={ROUTE_PATH.USER_EDIT_FORM_BUYER.LINK}
        component={withSuspense(UserEditFormBuyerContainer)}
      />
      <Route
        path={ROUTE_PATH.USER_DETAIL_FORM_ADMIN.LINK}
        component={withSuspense(UserDetailFormAdminContainer)}
      />
      <Route
        path={ROUTE_PATH.USER_EDIT_FORM_ADMIN.LINK}
        component={withSuspense(UserEditFormAdminContainer)}
      />
      <Route
        path={ROUTE_PATH.USER_DETAIL_FORM_SUPPLIER.LINK}
        component={withSuspense(UserDetailFormSupplierContainer)}
      />
      <Route
        path={ROUTE_PATH.USER_EDIT_FORM_SUPPLIER.LINK}
        component={withSuspense(UserEditFormSupplierContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK}
        component={withSuspense(UserManagementBuyerContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK}
        component={withSuspense(UserManagementAdminContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.USER_MANAGEMENT_SUPPLIER.LINK}
        component={withSuspense(UserManagementSupplierContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.UPLOAD_SUPPLIER_FORM.LINK}
        component={withSuspense(UploadSupplierFormAdminContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.UPLOAD_SUPPLIER_FORM_BUYER.LINK}
        component={withSuspense(UploadSupplierFormBuyerContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.CATEGORY_MANAGEMENT.LINK}
        component={withSuspense(CategoryManagementContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.CATEGORY_BUSINESS_GROUP_FORM.LINK}
        component={withSuspense(CategoryBusinessGroupFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.CATEGORY_SERVICE_GROUP_FORM.LINK}
        component={withSuspense(CategoryServiceGroupFormContainer)}
      />
      <Route
        exact
        path={
          `/${role.toLowerCase()}` +
          ROUTE_PATH.SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT.LINK
        }
        component={withSuspense(SustainabilityPreAssessmentManagementContainer)}
      />
      <Route
        exact
        path={
          `/${role.toLowerCase()}` +
          ROUTE_PATH.SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT.LINK
        }
        component={withSuspense(SustainabilityPreAssessmentManagementContainer)}
      />
      <Route
        exact
        path={
          `/${role.toLowerCase()}` +
          ROUTE_PATH.UPLOAD_SUSTAINABILITY_PRE_ASSESSMENT_FORM_ADMIN.LINK
        }
        component={withSuspense(
          UploadSustainabilityPreAssessmentFormAdminContainer
        )}
      />
      <Route
        exact
        path={ROUTE_PATH.BANNER_MANAGEMENT.LINK}
        component={withSuspense(BannerManagementContainer)}
      />
      <Route
        exact
        path={`/${role.toLowerCase()}` + ROUTE_PATH.BANNER_DETAIL_FORM.LINK}
        component={withSuspense(BannerDetailFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.ANNOUNCEMENT_MANAGEMENT.LINK}
        component={withSuspense(AnnouncementManagementContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.ANNOUNCEMENT_DETAIL_FORM.LINK}
        component={withSuspense(AnnouncementDetailFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.ESG_VERIFICATION.LINK}
        component={withSuspense(ESGVerificationContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.ESG_VERIFICATION_DETAIL_FORM.LINK}
        component={withSuspense(ESGVerificationDetailFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.COMPREHENSIVE_ASSESSMENT_MANAGEMENT.LINK}
        component={withSuspense(ComprehensiveAssessmentManagementContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.UPLOAD_COMPREHENSIVE_ASSESSMENT.LINK}
        component={withSuspense(UploadComprehensiveAssessmentFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.RISK_MANAGEMENT.LINK}
        component={withSuspense(RiskScoreManagementContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SUPPLIER_MANAGEMENT_INFORMATION_EDIT.LINK}
        component={withSuspense(SupplierManagementInformationEditContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_BUYER.LINK}
        component={withSuspense(SourcingBuyerContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_PROJECTS.LINK}
        component={withSuspense(SourcingProjectsContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_PROJECT_DETAIL.LINK}
        component={withSuspense(SourcingProjectDetailContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM.LINK}
        component={withSuspense(SourcingDetailBuyerFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_EDIT.LINK}
        component={withSuspense(SourcingDetailBuyerFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.TIPS_AND_TUTORIAL_ENGLISH_AUCTION.LINK}
        component={withSuspense(EnglishAuctionTutorial)}
      />
      <Route
        exact
        path={ROUTE_PATH.TIPS_AND_TUTORIAL_RFQ.LINK}
        component={withSuspense(RFQTutorial)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_COPYCREATE_EDIT.LINK}
        component={withSuspense(SourcingDetailBuyerFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_EVENT_EDIT.LINK}
        component={withSuspense(SourcingDetailBuyerFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_EVENTS_EDIT.LINK}
        component={withSuspense(SourcingDetailBuyerFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_COPYCREATE.LINK}
        component={withSuspense(SourcingDetailBuyerFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_COMPARE_EVENT.LINK}
        component={withSuspense(SourcingCompareEventContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_COMPARE_EVENTS.LINK}
        component={withSuspense(SourcingCompareEventContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_SUPPLIER.LINK}
        component={withSuspense(SourcingSupplierContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_AUCTION_BUYER.LINK}
        component={withSuspense(SourcingAuctionBuyerContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SOURCING_AUCTION_SUPPLIER.LINK}
        component={withSuspense(SourcingAuctionSupplierContainer)}
      />

      <Route
        exact
        path={ROUTE_PATH.SOURCING_DETAIL_SUPPLIER_FORM.LINK}
        component={withSuspense(SourcingDetailSupplierFormContainer)}
      />

      <Route
        path={ROUTE_PATH.ONLINE_TEMPLATE_MANEGEMENT.LINK}
        component={withSuspense(OnlineTemplateManegementContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SUPPLIER_ONLINE_TEMPLATE_MANAGEMENT.LINK}
        component={withSuspense(SupplierOnlineManagementContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.SUPPLIER_ONLINE_TEMPLATE_MANAGEMENT_MAIL.LINK}
        component={withSuspense(SupplierOnlineManagementContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.BUYER_ONLINE_TEMPLATE_MANAGEMENT.LINK}
        component={withSuspense(BuyerOnlineManagementContainer)}
      />
      <Route
        path={ROUTE_PATH.ACTIVATED_ACCOUNT.LINK}
        component={withSuspense(ActivatedContainer)}
      />
      <Redirect to={ROUTE_PATH.HOME.LINK} />
    </Switch>
  ),
  public: role => (
    <Switch>
      <Route
        exact
        path={ROUTE_PATH.LOGIN.LINK}
        component={withSuspense(LogInContainer)}
      />
      <Route
        path={ROUTE_PATH.ACTIVATED_ACCOUNT.LINK}
        component={withSuspense(ActivatedContainer)}
      />
      <Route
        path={ROUTE_PATH.CONTACT_ADMIN.LINK}
        component={withSuspense(ContactAdminContainer)}
      />
      <Route
        path={ROUTE_PATH.RESEND_EMAIL.LINK}
        component={withSuspense(ResendEmailContainer)}
      />
      <Route
        path={ROUTE_PATH.RESET_PASSWORD.LINK}
        component={withSuspense(ResetPasswordContainer)}
      />
      <Route
        path={ROUTE_PATH.SUPPLIER_REGISTRATION_FORM.LINK}
        component={withSuspense(SupplierRegistrationFormContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.LINK_TOKEN_EXPIRED.LINK}
        component={withSuspense(LinkTokenExpriedContainer)}
      />
      <Route
        exact
        path={ROUTE_PATH.LINK_HAVE_ACCOUNT.LINK}
        component={withSuspense(LinkHaveAccountContainer)}
      />
      <Redirect to={ROUTE_PATH.LOGIN.LINK} />
    </Switch>
  ),
}
